// extracted by mini-css-extract-plugin
module.exports = {"actions":"viewMovement_actions__3Z-Pb","accept":"viewMovement_accept__1AtAS","reject":"viewMovement_reject___r2gO","exitBtn":"viewMovement_exitBtn__3EKuO"};